<template>
  <article class="px-6 py-4 flex flex-col bg-white mb-4 shadow-lg relative">
    <div class="md:flex flex-1 items-baseline border-b mb-4 pb-4">
      <a
        :href="
          route(`funding.competitions.application.view`, {
            funding: fundingPot,
            competition: $page.competition.uuid,
            application: application.uuid
          })
        "
        class="block text-grey-900 hover:text-primary-700 no-underline flex-1"
      >
        <h2 class="text-xl leading-tight truncate">
          <span
            v-if="application.stream && !isSingleStream"
            class="border rounded px-2 py-1 align-bottom text-sm inline-block leading-none mr-2"
            :style="getStreamColorsByKey(application.stream)"
          >
            {{ getStreamNameByKey(application.stream) }}
          </span>
          {{ companyName | sentencecase }}
        </h2>
        <p class="mt-2">{{ applicantName }}</p>
      </a>
      <div class="flex mt-4 md:mt-0">
        <button
          v-if="application.rejected_at"
          class="px-4 py-3 border-2 border-grey-300 text-grey-800 shadow text-sm font-semibold bg-white hover:bg-gray-50 focus:outline-none focus:shadow-outline no-underline hover:bg-primary-100 hover:border-primary-300 leading-none mr-2 transition-all transition-normal"
          @click="approve"
        >
          Approve
        </button>
        <template
          v-if="
            rejectKeys &&
              application.submitted_at &&
              !application.invited_at &&
              !application.rejected_at
          "
        >
          <template v-if="isSingleStream">
            <button
              class="px-4 py-2 transition-all trainsition-normal focus:outline-none border-2 border-transparent shadow text-sm font-medium text-black bg-primary-500 hover:bg-primary-700 hover:text-white leading-none focus:shadow-outline transition-all transition-normal"
              @click="approve"
            >
              Approve
            </button>
          </template>
          <template v-else>
            <card-actions
              button-class="px-4 py-3 transition-all trainsition-normal focus:outline-none border-2 border-transparent shadow text-sm font-medium text-black bg-primary-500 hover:bg-primary-700 hover:text-white leading-none focus:shadow-outline transition-all transition-normal"
            >
              <template #icon> Approve </template>
              <p class="text-sm py-1 px-2 text-white bg-black">Switch Stream</p>
              <ul class="list-reset text-sm w-48 border-t-2 border-black">
                <li
                  v-for="({name, key, colors}) in availableStreams"
                  :key="key"
                >
                  <label
                    class="w-full p-2 flex items-baseline border-b justify-start cursor-pointer"
                    :style="selectedStream === key ? colors : ''"
                  >
                    <input
                      v-model="selectedStream"
                      type="radio"
                      :value="key"
                      :disabled="loading"
                      class="mr-2"
                    />
                    {{ name }}
                  </label>
                </li>
                <li>
                  <button
                    :disabled="loading || !selectedStream"
                    class="block uppercase font-bold tracking-wide p-2 text-center w-full transition-all transition-normal"
                    :class="{
                      'text-primary-800 bg-primayr-100 hover:bg-primary-200':
                        selectedStream && !loading,
                      'text-negative-800 bg-negative-100 hover:bg-negative-200':
                        !selectedStream && !loading,
                      'text-grey-800 bg-grey-100':
                        !selectedStream || loading
                    }"
                    @click="approve"
                  >
                    {{ loading ? "Approving..." : "Approve" }}
                  </button>
                </li>
              </ul>
            </card-actions>
          </template>
          <card-actions
            button-class="px-4 py-3 border-2 border-grey-300 text-grey-800 shadow text-sm font-semibold bg-white hover:bg-gray-50 focus:outline-none focus:shadow-outline no-underline hover:bg-negative-100 hover:border-negative-300 leading-none mr-2 transition-all transition-normal"
          >
            <template #icon> Reject </template>
            <ul class="list-reset text-sm w-48 border-t-2 border-black">
              <li v-for="(label, key) in rejectKeys" :key="key">
                <label
                  class="w-full p-2 flex items-baseline border-b border-grey-100 justify-start"
                >
                  <input
                    v-model="selectedRejectKeys"
                    type="checkbox"
                    :value="key"
                    :disabled="loading"
                    class="mr-2"
                  />
                  {{ label }}
                </label>
              </li>
              <li>
                <button
                  :disabled="loading || !selectedRejectKeys.length"
                  class="block uppercase font-bold tracking-wide p-2 text-center w-full transition-all transition-normal"
                  :class="{
                    'text-negative-800 bg-negative-100 hover:bg-negative-200':
                      selectedRejectKeys.length && !loading,
                    'text-grey-800 bg-grey-100':
                      !selectedRejectKeys.length || loading
                  }"
                  @click="reject"
                >
                  {{ loading ? "Rejecting..." : "Reject" }}
                </button>
              </li>
            </ul>
          </card-actions>
        </template>
        <a
          :href="
            route(`funding.competitions.application.view`, {
              funding: fundingPot,
              competition: $page.competition.uuid,
              application: application.uuid
            })
          "
          class="transition-all transition-normal inline-flex items-center px-4 py-3 border-2 border-grey-300 text-grey-800 shadow text-sm font-semibold bg-white hover:bg-gray-50 focus:outline-none focus:shadow-outline no-underline hover:bg-primary-100 hover:border-primary-300 leading-none ml-2"
        >
          View
        </a>
      </div>
    </div>
    <div class="flex items-center">
      <app-badge :type="group.status" :icon="group.icon" class="mr-4">
        {{ group.badge }}
      </app-badge>
      <p class="mr-2 text-sm text-grey-700 truncate flex-1">
        <template v-if="$page.competition.type.key === 'EOI'">
          {{ application.title }}
        </template>
        <template v-else>
          [{{ application.ref }}] {{ application.title }}
        </template>
      </p>
      <div class="flex items-baseline ml-auto flex-no-shrink">
        <a
          v-if="application.submitted_at"
          class="block text-sm font-bold text-primary-600 ml-4 no-underline"
          :href="route('applications.pdf', { application: application.uuid })"
          target="_blank"
        >
          PDF
        </a>
        <a
          v-if="
            application.submitted_at && $page.competition.type.key !== 'EOI'
          "
          class="block text-sm font-bold text-primary-600 ml-4 no-underline"
          :href="
            route('applications.download', {
              application: application.uuid
            })
          "
          target="_blank"
        >
          Download ZIP
        </a>
        <funding-submission-notes
          v-if="logs"
          :logs="logs"
          :application-uuid="application.uuid"
        />
      </div>
    </div>
    <div
      v-if="
        !application.submitted_at && application.application_progress_percentage
      "
      class="relative -mx-6 -mb-4 h-8 mt-2 overflow-hidden z-0"
    >
      <div
        class="bg-neutral-100 border-neutral-400 absolute h-full pin-t overflow-hidden border-t z-0 text-neutral-600 text-xs flex items-center w-full whitespace-no-wrap"
      >
        <p class="px-6">
          Progress:
          <b>{{ application.application_progress_percentage }}%</b>
        </p>
      </div>
      <div
        class="bg-neutral-200 border-neutral-500 absolute h-full pin-t overflow-hidden border-t z-0 text-neutral-800 text-xs flex items-center whitespace-no-wrap"
        :style="`width: ${application.application_progress_percentage}%`"
        aria-hidden="hidden"
      >
        <p class="px-6">
          Progress:
          <b>{{ application.application_progress_percentage }}%</b>
        </p>
      </div>
    </div>
  </article>
</template>

<script>
import CardActions from "../../components/cards/CardActions.vue";
import { competitionStreamsMixin } from "../../mixins/competitionStreams.js";
export default {
  name: "FundingCompetitionSubmission",
  components: { CardActions },
  mixins: [competitionStreamsMixin],
  props: {
    group: {
      type: Object,
      required: true
    },
    application: {
      type: Object,
      required: true
    },
    fundingPot: {
      type: Number,
      required: true
    },
    rejectKeys: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      selectedRejectKeys: [],
      selectedStream: this.application.stream
    };
  },
  computed: {
    applicantName() {
      return this.application.user?.name || "[Deleted User]";
    },
    companyName() {
      const companyName = this.application.user?.company?.name;
      return companyName || "[Deleted Company]";
    },
    logs() {
      return this.application?.log ?? false;
    }
  },
  methods: {
    approve() {
      // send approval route(funding.eoi.update, { funding_pot.id, application.this.application.uuid })
      if (
        this.application.rejected_at &&
        !confirm("Are you sure you want to approve this rejected project?")
      )
        return;
      this.loading = true;
      axios
        .post(
          this.route("funding.eoi.update", {
            funding: this.fundingPot,
            application: this.application.uuid
          }),
          {
            status: "accept",
            stream: this.selectedStream
          }
        )
        .then(() => Turbolinks.visit(window.location.pathname))
        .catch(() => (this.loading = false));
    },
    reject() {
      this.loading = true;
      axios
        .post(
          this.route("funding.eoi.update", {
            funding: this.fundingPot,
            application: this.application.uuid
          }),
          {
            status: "reject",
            reject_keys: this.selectedRejectKeys
          }
        )
        .then(() => Turbolinks.visit(window.location.pathname))
        .catch(() => (this.loading = false));
    }
  }
};
</script>
